export const financeRoutes = [
    {
        path: 'payments',
        name: 'payments',
        component: () => import('../../views/Payments.vue'),
        meta: {
            requiresAuth: true,
            requiredPermission: 'payments.view'
        }
    },
    {
        path: 'expenses',
        name: 'expenses',
        component: () => import('../../views/Expenses.vue'),
        meta: {
            requiresAuth: true,
            requiredPermission: 'expenses.view'
        }
    },
    {
        path: 'expenses-dashboard',
        name: 'expenses-dashboard',
        component: () => import('../../views/ExpensesDashboard.vue'),
        meta: {
            requiresAuth: true,
            requiredPermission: 'expenses.edit'
        }
    },
    {
        path: 'requisitions',
        name: 'requisitions',
        component: () => import('../../views/Requisitions.vue'),
        meta: {
            requiresAuth: true,
            requiredPermission: 'requisitions.view'
        }
    },
    {
        path: 'suppliers',
        name: 'suppliers',
        component: () => import('../../views/Suppliers.vue'),
        meta: {
            requiresAuth: true,
            requiredPermission: 'suppliers.view'
        }
    },
    {
        path: 'clients',
        name: 'clients',
        component: () => import('../../views/Clients.vue'),
        meta: {
            requiresAuth: true,
            requiredPermission: 'clients.view'
        }
    },
    {
        path: '/management/approvals',
        name: 'management-approvals',
        component: () => import('@/views/ForApprovals.vue'),
        meta: {
            requiresAuth: true,
            title: 'Approvals',
            permissions: ['payments.approve', 'expenses.approve', 'orders.approve', 'requisitions.approve'],
            section: 'management'
        }
    }
];
